import { RoomId, roomId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandLogoDeleteEventDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandLogoDeleteEventDTO.validationSchema()
  );

  constructor(readonly data: RoomBrandLogoDeleteEvent) {
    JsonSchemaValidator.assert(RoomBrandLogoDeleteEventDTO.validation, data);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId"],
      properties: {
        roomId
      }
    };
  }
}

interface RoomBrandLogoDeleteEvent {
  roomId: RoomId;
}
